import { Section, SectionProps } from "@/components/Sections";
import { sectionPaddingYClassname } from "./Sections";
import { PropsWithChildren } from "react";
import { mcn } from "@/utils/mergeClassNames";

type Props = SectionProps;

type ColumnProps = PropsWithChildren<{
  className?: string;
}>;

export const ColumnsSectionLeft = (props: ColumnProps) => {
  return (
    <div
      className={mcn(
        "col-span-full tablet-lg:col-span-6",
        sectionPaddingYClassname,
        props.className
      )}
    >
      {props.children}
    </div>
  );
};
export const ColumnsSectionRight = (props: ColumnProps) => {
  return (
    <div
      className={mcn(
        "col-span-full tablet-lg:col-span-4",
        "bg-blue",
        "bg-fill-right max-tablet:bg-fill-left ",
        sectionPaddingYClassname,
        props.className
      )}
    >
      {props.children}
    </div>
  );
};

export const ColumnsSectionSeperator = (props: {
  colSpan?: "col-span-1" | "col-span-2";
}) => {
  return (
    <div
      className={mcn(
        "hidden tablet-lg:flex -mx-gap",
        props.colSpan ?? "col-span-2"
      )}
    >
      <div className="w-1/2 bg-transparent" />
      <div className="w-1/2 bg-blue " />
    </div>
  );
};

export const ColumnsSection = ({ children, ...sectionProps }: Props) => {
  return (
    <Section {...sectionProps}>
      <div className="container grid grid-cols-12 gap-default">{children}</div>
    </Section>
  );
};
